import { BubbleFormGroup } from './BubbleUI';
import React from 'react';
import { timeToMinutes } from '@go-shared/lib/time';
import { Mcm } from '@go-shared/types/mcm';
import McmVisibilityTable from './McmVisibilityTable';
import { Plan, VenueDisposition } from '@go-shared/types/plan';
import { getBasicTimeStrings } from '@go-shared/lib/venue';
import { VenueTemplate } from '@go-shared/types/venueTemplate';
import { getHourFormat } from '@go-shared/lib/property';
import { useActiveProperty } from '@go-client/context/ActivePropertyContext';
import AudienceVisibilityTable from './AudienceVisibilityTable';
import { Audience } from '@go-shared/types/audience';

interface VenuesGlanceProps {
  plan: Plan;
  venue: VenueDisposition;
  template: VenueTemplate;
  locked?: boolean;
  name?: string;
  times?: string[];
  onUpdateVenue?: (venue: VenueDisposition) => void;
}

export default function VenuesGlance(props: VenuesGlanceProps) {
  const { plan, venue, template } = props;
  const { activeProperty: property } = useActiveProperty();

  const dayStart = plan.dayStart;
  const dayStartMinutes = timeToMinutes(dayStart);

  const hourFormat = getHourFormat(property);

  const availabilities = getBasicTimeStrings(venue.hours, dayStartMinutes, hourFormat);

  async function onUpdateVenueMcm(mcm: Mcm) {
    if (props.onUpdateVenue) {
      await props.onUpdateVenue({ ...venue, mcm });
    }
  }

  async function onUpdateVenueAudience(audience: Audience) {
    if (props.onUpdateVenue) {
      await props.onUpdateVenue({ ...venue, audience });
    }
  }

  return (
    <div className="grid grid-cols-6 gap-4">
      <BubbleFormGroup label="Name" className="col-span-3">
        {props.name || template.name}
      </BubbleFormGroup>
      <BubbleFormGroup label="Time" className="col-span-3">
        {(props.times || availabilities).map((ts, i) => (
          <div key={`${ts}_${i}`} className="whitespace-nowrap">
            {ts}
          </div>
        ))}
      </BubbleFormGroup>
      <BubbleFormGroup className="col-span-6" label="Endpoints">
        <McmVisibilityTable
          isTemplate={false}
          readOnly={props.locked}
          sourceMcm={venue.mcm}
          parentMcm={template.mcm}
          onUpdateMcm={onUpdateVenueMcm}
        />
      </BubbleFormGroup>
      <BubbleFormGroup className="col-span-6" label="Audience">
        <AudienceVisibilityTable
          isTemplate={false}
          readOnly={props.locked}
          sourceAud={venue.audience}
          parentAud={template.audience}
          onUpdateAudience={onUpdateVenueAudience}
        />
      </BubbleFormGroup>
    </div>
  );
}
